import React, {useMemo, Suspense, lazy, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import {connect} from 'react-redux'

import syncFilters from 'js/components/shared/actions/syncFilters'
import ModulePreview from '../../components/ModulePreview';
import {filters} from '../../drupalSettings';
import filterChange from '../../actions/filterChange';
import filterApply from '../../actions/filterApply';
import {FILTER_ROOMS} from '../../constants';
import {pushFiltersApply, pushFiltersClose} from 'js/helpers/gtm';

import styles from './SearchModuleRooms.module.scss';

const ModuleRoomsForm = lazy(() => import('./components/ModuleRoomsForm'));

const cx = classnames.bind(styles);
const wordings = filters?.rooms;

const countGuests = (rooms, guest) => {
  let guests = 0
  rooms.filter(room => room[guest] > 0)
    .forEach((room) => { guests += room[guest] })
  return guests
}
const SearchModuleRooms = function ({
  data,
  className,
  activeFilter,
  syncFiltersAction,
  filterChangeAction,
  filterApplyAction,
}) {
  const [destinationQuery, setDestinationQuery] = useState()
  const previewLabel = useMemo(() => {
    const roomsLabel = [];
    const roomsCount = data.length;
    const {
      adult,
      adults,
      child,
      children,
      baby,
      babies,
      room,
      rooms,
    } = wordings;

    if (roomsCount > 0) {
      roomsLabel.push(`${roomsCount} ${roomsCount > 1 ? rooms : room}`)

      const adultsCount = countGuests(data, 'adults')
      if (adultsCount > 0) {
        roomsLabel.push(`${adultsCount} ${adultsCount > 1 ? adults : adult}`)
      }

      const childrenCount = countGuests(data, 'children')
      if (childrenCount > 0) {
        roomsLabel.push(`${childrenCount} ${childrenCount > 1 ? children : child}`)
      }

      const babiesCount = countGuests(data, 'babies')
      if (babiesCount > 0) {
        roomsLabel.push(`${babiesCount} ${babiesCount > 1 ? babies : baby}`)
      }
    }
    return roomsLabel.length > 0 ? roomsLabel.join(', ') : null
  }, [data, wordings])
  const isActive = useMemo(() => activeFilter === FILTER_ROOMS, [activeFilter])
  const previewValues = useMemo(function () {
    return [{
      label: wordings.label,
      value: previewLabel,
      readOnly: true,
    }]
  }, [previewLabel])

  const onFormSubmit = function (data) {
    filterChangeAction(FILTER_ROOMS, data)
    filterApplyAction(FILTER_ROOMS, true)
    syncFiltersAction(true)
    pushFiltersApply('rooms')
    closeModal()
  }

  const onPreviewClick = function () {
    filterChangeAction('activeFilter', FILTER_ROOMS)
  }

  const onFormClose = function () {
    pushFiltersClose('rooms')
    closeModal()
  }

  const closeModal = () => {
    filterChangeAction('activeFilter', null)
  }

  useEffect(() => {
    setDestinationQuery()
  }, []);

  return (
    <div className={cx('root', className)}>
      <ModulePreview
        icon="PARTICIPANT"
        values={previewValues}
        onClick={onPreviewClick}
      />
      {isActive && (
        <Suspense>
          <ModuleRoomsForm
            rooms={data}
            onSubmit={onFormSubmit}
            onClose={onFormClose}
          />
        </Suspense>
      )}
    </div>
  )
}

SearchModuleRooms.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object.isRequired),
}

export default connect(({form}) => ({
  data: form?.searchFilters?.rooms || [],
  activeFilter: form?.searchFilters?.activeFilter,
}), {
  filterChangeAction: filterChange,
  filterApplyAction: filterApply,
  syncFiltersAction: syncFilters,
})(SearchModuleRooms);
